import React from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@epic-ui/epic/src/index';
import {Message, Button, priority} from 'epic-diesel-common';
import {EulaItem} from '../';
import {Eula} from '../../reducers/eula.reducer';
import styled from 'styled-components';

const DialogButton = styled(Button)`
    opacity: 0.4;
    border: none !important;
`;

interface Props {
    open: boolean;
    onClose: (event?) => void;
    eula: Eula;
}

const AgreementDialog: React.FunctionComponent<Props> = ({open, onClose, eula}) => (
    <Dialog open={open} fullwidth="true">
        <DialogTitle>{eula.title}</DialogTitle>
        <DialogContent>
            <EulaItem
                item={eula}
                titleProps={{
                    variant: 'body2',
                    align: undefined,
                    style: {padding: 0, display: 'none'}
                }}
            />
        </DialogContent>
        <DialogActions>
            <DialogButton priority={priority.SECONDARY} onClick={onClose} theme="darkGray">
                <Message code="epic.affiliate.common.close" />
            </DialogButton>
        </DialogActions>
    </Dialog>
);

export default AgreementDialog;
